import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { studentCertificatesManagement } from "../../../../../../hooks/api/StudentCertificatesManagement/StudentCertificatesManagement";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";

const EditCertificate = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { certificateId } = useParams();
    const [formErrors, setFormErrors] = useState([]);
    const { useUpdateStudentCertificateMutation, useViewStudentCertificateMutation} = studentCertificatesManagement;
    const [updateCertificate, {isLoading: isUpdateingCertificate}] = useUpdateStudentCertificateMutation();
    const [viewCertificate] = useViewStudentCertificateMutation();

    const tabs = [
        { title: t("schools.title"), onClick: () => gotoSchoolTab() },
        { title: t("certificates.title"), isActive: true },
        { title: t("address.title"), onClick: () => gotoAddressTab()},
    ];

    const gotoSchoolTab = () => {
        navigate("/settings/students/schools");
    };

    const gotoAddressTab = () => {
        navigate("/settings/students/address");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {...values};
        updateCertificate({body, certificateId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/students/certificates");
                toast.info(result?.data?.info?.responseMessage);
            }
        });
    };

    useEffect(() => {
        viewCertificate(certificateId).then((result) => {
            formRef.current.setValues(result?.data);
            console.log(result?.data);
        });

    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/students/certificates" />
                <Button title={t('save')} isDisabled={isUpdateingCertificate} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("students.title")} />
                    <Link title={t("certificates.title")} />
                    <Link title={t("certificates.updateOne")} isActive={true} />
                </Breadcrumps>
                <Formik
                        innerRef={formRef}
                        initialValues={{
                            name: ""
                        }}
                        onSubmit={onSaved}
                    >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Input
                                        name="name"
                                        label={t("certificates.name")}
                                        required={true}
                                        value={values.name}
                                        onChange={handleChange}
                                        error={formErrors?.name}
                                    />
                                </Field>                     
                            </Row>
                            
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditCertificate;